import { StatementListResponseType } from "@sellar-io/api-v2/types";
import {
  Badge,
  BadgeGreen,
  BadgeZinc,
  BadgeRed,
  BadgeBlue,
} from "@sellar-io/components";

import dayjs from "dayjs";

export const StatementPaymentStatusBadge = ({
  statement,
}: {
  statement: StatementListResponseType[number];
}) => {
  const dispatched = dayjs(statement.createdAt);
  const dueDate = dispatched.endOf("month").add(30, "days");

  switch (statement.status) {
    case "draft":
      return <Badge>Draft</Badge>;

    case "paid":
      return <BadgeGreen>Paid</BadgeGreen>;

    case "issued":
      return <BadgeZinc>Issued: Due {dueDate.format("MMM DD")}</BadgeZinc>;

    case "void":
      return <BadgeRed>Void</BadgeRed>;

    case "payment_processing":
      return <BadgeBlue>Payment processing</BadgeBlue>;

    default:
      return "-";
  }
};
